import { render, staticRenderFns } from "./PaymentCOD.vue?vue&type=template&id=7ac0dfc2&scoped=true"
import script from "./PaymentCOD.vue?vue&type=script&lang=js"
export * from "./PaymentCOD.vue?vue&type=script&lang=js"
import style0 from "./PaymentCOD.vue?vue&type=style&index=0&id=7ac0dfc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac0dfc2",
  null
  
)

export default component.exports